import axios from "axios";
import NewExpense from "./components/NewExpense";
import CategoriesPage from "./components/CategoriesPage";
import Table from "../../components/Table";
import DatePicker from "react-datepicker";
import { useState, useEffect } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import { ENDPOINT } from "../../constants/endpointConstants";
import { getToken, getRangeDates, formatDateTime } from "../../utils/utils";
import "./ExpensesPage.css";

const ExpensesPage = () => {
  const [showNewExpense, setShowNewExpense] = useState(false);
  const [showModalInvoice, setShowModalInvoice] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [invoiceCacheBuster, setInvoiceCacheBuster] = useState(Date.now());
  const [invoiceSelected, setInvoiceSelected] = useState();
  const [invoiceToUpdate, setInvoiceToUpdate] = useState();
  const [expensesInformation, setExpensesInformation] = useState({
    expenses: [],
    total: 0,
    pagesAmount: 0,
    page: 1,
    size: 10,
  });
  const [isLoadingExpenses, setIsLoadingExpenses] = useState(false);
  const [sortBy, setSortBy] = useState("expenseDate");
  const [sortDirection, setSortDirection] = useState("desc");
  const [dateRange, setDateRange] = useState(
    getRangeDates(new Date(), new Date())
  );

  const [startDate, endDate] = dateRange;
  const [expensesCategories, setExpensesCategories] = useState([]);
  const [activeTab, setActiveTab] = useState("movimientos");

  const getExpensesData = async (
    startDate,
    endDate,
    page = 1,
    size = 10,
    sortByParam = sortBy,
    sortDirectionParam = sortDirection
  ) => {
    const token = getToken();
    const payload = {
      startDate: startDate,
      endDate: endDate,
      page,
      size,
      sortBy: sortByParam,
      sortDirection: sortDirectionParam,
    };
    try {
      setIsLoadingExpenses(true);
      const { data } = await axios.post(ENDPOINT.GET_EXPENSES, payload, token);
      setExpensesInformation({ ...data, page, size });
      setIsLoadingExpenses(false);
    } catch (error) {
      setIsLoadingExpenses(false);
      console.error("Error fetching expenses:", error);
    }
  };

  const getExpensesCategories = async () => {
    const token = getToken();
    try {
      const { data } = await axios.get(ENDPOINT.GET_EXPENSES_CATEGORIES, token);
      setExpensesCategories(data);
    } catch (error) {
      console.error("Error fetching expenses categories:", error);
    }
  };

  useEffect(() => {
    getExpensesData(
      formatDateTime(dateRange[0]),
      formatDateTime(dateRange[1]),
      expensesInformation.page,
      expensesInformation.size
    );
    getExpensesCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showInvoice = async (invoice) => {
    const token = getToken();
    try {
      const { data } = await axios.get(
        `${ENDPOINT.GET_INVOICE}/${invoice.invoiceId}`,
        token
      );
      const invoiceWithImagePath = {
        ...invoice,
        invoiceImagePath: data.invoiceImagePath,
      };
      setInvoiceSelected(invoiceWithImagePath);
      setInvoiceCacheBuster(Date.now());
      setShowModalInvoice(true);
    } catch {
      setInvoiceSelected(invoice);
      setInvoiceCacheBuster(Date.now());
      setShowModalInvoice(true);
    }
  };

  const updateInvoice = (invoice) => {
    setInvoiceToUpdate(invoice);
    setIsUpdateMode(true);
    setShowNewExpense(true);
  };

  const newExpense = () => {
    getExpensesData(
      formatDateTime(dateRange[0]),
      formatDateTime(dateRange[1]),
      expensesInformation.page,
      expensesInformation.size
    );
  };

  const expensesColumns = [
    {
      name: "Fecha",
      key: "date",
      colSize: "col-2",
      type: "shortDate",
      sortKey: "expenseDate",
    },
    {
      name: "Categoria",
      key: "categoryName",
      colSize: "col-3",
    },
    {
      name: "Precio",
      key: "price",
      colSize: "col-2",
      type: "currency",
      sortKey: "price",
    },
    {
      name: "Cantidad",
      key: "amount",
      colSize: "col-2",
      sortKey: "amount",
    },
    {
      name: "Unidad",
      key: "unitType",
      colSize: "col-1",
    },
    {
      name: "Acciones",
      type: "actions",
      colSize: "col-2",
      buttons: [
        {
          iconClass: "fa-solid fa-file-invoice-dollar",
          action: showInvoice,
        },
        {
          iconClass: "fa-solid fa-edit",
          action: updateInvoice,
        },
      ],
    },
  ];

  const showModalNewExpense = () => {
    getExpensesCategories();
    setShowNewExpense(true);
  };

  const modalClose = () => {
    setShowNewExpense(false);
    setIsUpdateMode(false);
  };

  const modalCloseInvoice = () => {
    setShowModalInvoice(false);
  };

  const modalCloseUpdateInvoice = () => {
    setShowNewExpense(false);
    setIsUpdateMode(false);
  };

  const handlePageChange = (newPage) => {
    getExpensesData(
      startDate,
      endDate,
      newPage,
      expensesInformation.size,
      sortBy,
      sortDirection
    );
  };

  const handleSortChange = (newSortBy) => {
    const isSameColumn = newSortBy === sortBy;
    const newSortDirection =
      isSameColumn && sortDirection === "asc" ? "desc" : "asc";
    setSortBy(newSortBy);
    setSortDirection(newSortDirection);
    getExpensesData(
      startDate,
      endDate,
      1,
      expensesInformation.size,
      newSortBy,
      newSortDirection
    );
  };

  const datePickerOnChange = (update) => {
    const [dateInit, dateFinish] = getRangeDates(update[0], update[1]);
    setDateRange([dateInit, dateFinish]);
    if (update[0] && update[1]) {
      getExpensesData(formatDateTime(dateInit), formatDateTime(dateFinish));
    }
  };

  return (
    <div>
      <section>
        <div className="mx-4">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-5 mt-3 expenses-tabs"
          >
            <Tab eventKey="movimientos" title="Movimientos">
              <div className="row">
                <div className="col-md-9 col-12 mb-4">
                  <p className="mt-4 mb-4">
                    {" "}
                    Selecciona la fecha o el rango de fechas a consultar{" "}
                  </p>
                  <div className="row">
                    <div className="col-md-3 col-8">
                      <DatePicker
                        key={"expense-date-picker"}
                        selectsRange={true}
                        startDate={startDate}
                        dateFormat="yyyy/MM/dd"
                        endDate={endDate}
                        onChange={datePickerOnChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-12">
                  <div className="row mt-md-0 mt-3">
                    <div className="col-md-12 col-6">
                      <div className="style-cards">
                        <i className="fa-solid fa-file-invoice-dollar style-icon-sale"></i>
                        <div className="d-flex  flex-column">
                          <p className="bold"> Total </p>
                          <p>
                            {" "}
                            {"$" +
                              new Intl.NumberFormat("es-CL").format(
                                expensesInformation.total
                              )}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12">
                    <div className="d-flex justify-content-end mb-3 mt-5 mt-sm-0">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm new-expenses-btn"
                        data-bs-target="#modal"
                        onClick={showModalNewExpense}
                      >
                        <i className="fa-solid fa-plus"></i> Nuevo Gasto
                      </button>
                    </div>
                    <Table
                      columnNames={expensesColumns}
                      items={expensesInformation.expenses}
                      fixSize={"t-responsive-large"}
                      isLoading={isLoadingExpenses}
                      pagination={true}
                      totalItems={expensesInformation.totalExpensesAmount}
                      currentPage={expensesInformation.page}
                      onPageChange={handlePageChange}
                      sortBy={sortBy}
                      sortDirection={sortDirection}
                      onSortChange={handleSortChange}
                    />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="categorias" title="Categorias">
              <CategoriesPage />
            </Tab>
          </Tabs>
        </div>
      </section>
      <Modal
        show={showNewExpense}
        onHide={isUpdateMode ? modalCloseUpdateInvoice : modalClose}
      >
        <Modal.Header closeButton className="style-modal-header">
          <Modal.Title className="text-modal">
            {" "}
            {isUpdateMode ? "Actualizar Gasto" : "Gasto"}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewExpense
            pushNewExpense={newExpense}
            expensesCategories={expensesCategories}
            invoiceId={invoiceToUpdate?.invoiceId}
            isUpdateMode={isUpdateMode}
            onUpdateSuccess={() => {
              getExpensesData(
                formatDateTime(dateRange[0]),
                formatDateTime(dateRange[1]),
                expensesInformation.page,
                expensesInformation.size
              );
            }}
            onClose={modalCloseUpdateInvoice}
          />
        </Modal.Body>
      </Modal>
      <Modal show={showModalInvoice} onHide={modalCloseInvoice}>
        <Modal.Header closeButton className="style-modal-header">
          <Modal.Title className="text-modal"> Factura </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            alt="invoice"
            className="invoice-img"
            src={
              invoiceSelected?.invoiceImagePath
                ? `https://que-bendicion-invoices.s3.us-west-2.amazonaws.com/${invoiceSelected.invoiceImagePath}?t=${invoiceCacheBuster}`
                : `https://que-bendicion-invoices.s3.us-west-2.amazonaws.com/expenses/expense_${invoiceSelected?.expenseId}${invoiceSelected?.imgType}?t=${invoiceCacheBuster}`
            }
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExpensesPage;
